import { type DropdownOption } from '~/_shared/baseComponents/dropdown';
import { type TranslationFnc } from '~/_shared/utils/hooks';

export enum LoadCustomBoundaryFillType {
  DefaultFill = 'DefaultFill',
  NoTerritoryFill = 'NoTerritoryFill',
  RandomizedFill = 'RandomizedFill',
  FillBasedOnData = 'FillBasedOnData',
}

export const getBoundaryFillTypeOptions = (t: TranslationFnc): ReadonlyArray<DropdownOption<LoadCustomBoundaryFillType>> => {
  return [{
    name: t('Default Fill'),
    value: LoadCustomBoundaryFillType.DefaultFill,
  }, {
    name: t('No Territory Fill'),
    value: LoadCustomBoundaryFillType.NoTerritoryFill,
  }, {
    name: t('Randomized Fill'),
    value: LoadCustomBoundaryFillType.RandomizedFill,
  }, {
    name: t('Fill Based on Data'),
    value: LoadCustomBoundaryFillType.FillBasedOnData,
  }];
};

export function trimOptimizedTerritoryGroupNameMadeForTesting(input: string, maxLength = 46): string {
  const dateRegex = /\(\d{2}\.\d{2}\.\d{4}, \d{2}:\d{2}:\d{2}\)$/;
  const dateMatch = dateRegex.exec(input);

  if (!dateMatch) {
    return input;
  }

  const dateStr = dateMatch[0];
  const dateStartIndex = dateMatch.index;
  const prefixFull = input.slice(0, dateStartIndex).trim();

  const startPhrase = 'Territories from';
  const shortenedStart = 'Terr. from';

  const dateLength = dateStr.length + 1;

  if (prefixFull.startsWith(startPhrase)) {
    const name = prefixFull.slice(startPhrase.length).trim();
    const start = shortenedStart;

    const remaining = maxLength - dateLength - start.length - 1;

    let trimmedName = name;
    if (trimmedName.length > remaining) {
      trimmedName = trimmedName.slice(0, remaining - 3).trimEnd() + '...';
    }

    return `${start} ${trimmedName} ${dateStr}`;
  }

  const remaining = maxLength - dateLength;
  let trimmedPrefix = prefixFull;

  if (trimmedPrefix.length > remaining) {
    trimmedPrefix = trimmedPrefix.slice(0, remaining - 1).trimEnd() + '…';
  }

  return `${trimmedPrefix} ${dateStr}`;
}
